'use client'

import { createContext, useContext, type ReactNode } from 'react'

const HostSiteLinkBaseContext = createContext<string | null>(null)

/** Base path for host marketing routes, e.g. `/en` or `/test` (no trailing slash). */
export function HostSiteLinkBaseProvider({ base, children }: { base: string; children: ReactNode }) {
    const normalized = base.replace(/\/$/, '') || '/'
    return <HostSiteLinkBaseContext.Provider value={normalized}>{children}</HostSiteLinkBaseContext.Provider>
}

export function useHostSiteLinkBase(): string {
    const ctx = useContext(HostSiteLinkBaseContext)
    if (ctx == null) {
        throw new Error('Host marketing components must render inside HostSiteLinkBaseProvider.')
    }
    return ctx
}
